<pt-feature-info />
<pt-breadcrumbs class="bg-white" [breadcrumbs]="breadcrumbs()" />
<div class="border-b border-solid border-slate-300"></div>

<div class="mx-auto flex max-w-5xl flex-col gap-4 p-4">
  <h1 class="mat-headline-4 !mb-0">Patient Portal</h1>

  <pr-content-container>
    <h2 class="text-xl font-bold">Restrictions</h2>

    <div class="flex flex-col gap-4">
      <p class="text-md !mb-0 font-bold">Date Range Restrictions</p>

      <pr-information-box>
        Restrict the date range that patients can book appointments.
      </pr-information-box>

      <div class="flex flex-row gap-4 md:flex-row md:gap-6">
        <pr-online-booking-time-restriction-form
          label="Minimum Booking Time"
          hint="Patients can not book appointments until after this time."
          defaultPlaceholder="Default (0 days)"
          [value]="minBookingWindow()"
          (bookingWindowChange)="onMinBookingWindowChange($event)"
        />

        <pr-online-booking-time-restriction-form
          label="Maximum Booking Time"
          [hint]="'Patients can book appointments up to this time. (Hard limit of ' + maxBookingWindowDays + ' days)'"
          defaultPlaceholder="Default (45 days)"
          [value]="maxBookingWindow()"
          (bookingWindowChange)="onMaxBookingWindowChange($event)"
        />
      </div>
    </div>
  </pr-content-container>

  <pr-content-container>
    <h2 class="text-xl font-bold">Staff</h2>

    <div class="flex flex-col gap-4">
      <p class="text-md !mb-0 font-bold">Order By</p>

      <pr-information-box>
        The order in which staff are displayed on the online booking page.
      </pr-information-box>

      <mat-form-field class="w-full">
        <mat-label>Order Staff</mat-label>
        <mat-select [formControl]="orderBy">
          <mat-select-trigger>{{
            selectedStaffOrderLabel()
          }}</mat-select-trigger>
          @for (option of staffOrderOptions; track option.value) {
            <mat-option class="!h-auto py-3" [value]="option.value">
              <div class="flex flex-col gap-1">
                <span class="font-medium">{{ option.label }}</span>
                <span class="mat-caption">{{ option.description }}</span>
              </div>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (orderBy.value === staffOrderOptionEnum.Custom) {
        <mat-list cdkDropList (cdkDropListDropped)="dropStaffer($event)">
          @for (staffer of staff(); track staffer.ref.path) {
            <div class="flex" cdkDrag>
              <div
                class="flex cursor-move items-center justify-center"
                cdkDragHandle
              >
                <mat-icon>drag_handle</mat-icon>
              </div>
              <mat-list-item>
                {{ staffer.user.name | titlecase }}
              </mat-list-item>
            </div>
          }
        </mat-list>
      }
    </div>
  </pr-content-container>
</div>
